module.exports = "<input type=\"number\" ng-model=\"value\" class=\"col-xs-12\">";